import React from 'react';
import Button from './Button';
import AgentCard from './AgentCard';

/**
 * Panel for managing virtual agents in LVC scenario
 */
const VirtualAgentsPanel = ({
  agents,
  getUserByUid,
  getAgentStats,
  profilePictures,
  failedProfilePictures,
  openAgentMenu,
  onMenuToggle,
  onAddUser,
  onSwap,
  onRemove,
  onAddBehavior,
  onUserClick,
  onNameClick,
  onProfilePictureError,
  disabled = false
}) => {
  return (
    <>
      <div className="virtual-panel-header">
        <h2>Virtual</h2>
        <Button
          variant="primary"
          size="small"
          onClick={onAddUser}
          disabled={disabled}
        >
          Add User
        </Button>
      </div>
      <div className="virtual-names-list">
        {agents.length === 0 ? (
          <p className="empty-message">No virtual agents added yet. Click "Add User" to get started.</p>
        ) : (
          <ul className="names-list">
            {agents.map((agent, index) => {
              const user = getUserByUid(agent.uid);
              const stats = getAgentStats(agent);
              const profilePictureUrl = user ? profilePictures.get(agent.uid) : null;
              const showProfilePicture = profilePictureUrl && !failedProfilePictures.has(agent.uid);
              const isMenuOpen = openAgentMenu === index;
              
              return (
                <AgentCard
                  key={index}
                  agent={agent}
                  user={user}
                  profilePictureUrl={profilePictureUrl}
                  showProfilePicture={showProfilePicture}
                  isMenuOpen={isMenuOpen}
                  onMenuToggle={() => onMenuToggle(isMenuOpen ? null : index)}
                  onSwap={() => onSwap(index)}
                  onRemove={() => onRemove(index)}
                  onProfilePictureError={() => onProfilePictureError(agent.uid)}
                  onUserClick={onUserClick}
                  onNameClick={() => onNameClick(index)}
                  disabled={disabled}
                  stats={stats}
                  onAddBehavior={() => onAddBehavior(index)}
                />
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};

export default VirtualAgentsPanel;
